import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class DemandStatusModel extends ApiModel {
  static get path() {
    return '/backend/demand_statuses/{?id}';
  }

  @computed
  get label() {
    return this.get('label', '');
  }

  @computed
  get reference() {
    return this.get('reference', '');
  }
}
